<template>
  <el-dialog
    v-loading="loading"
    :visible.sync="visible"
    :append-to-body="true"
    title="افزودن گروهی دستگاه"
    width="500px"
  >
    <el-form @submit.native.prevent="submit">
      <el-row :gutter="10">
        <el-col v-if="!result.show" :sm="24" class="mb-3">
          <p class="text-muted font-11 required">فایل اکسل</p>
          <div
            class="v-image-picker"
            :class="{ 'v-image-picker-has-preview': file != null }"
          >
            <drop-zone
              :placeholder="file != null ? 'تغییر فایل' : 'انتخاب فایل'"
              type="excel"
              @change="handleFileChange($event)"
            />
            <div v-if="file != null" class="v-image-picker-preview">
              <i class="el-icon-delete v-image-picker-delete" @click="clear" />
              <div class="v-image-picker-preview-image">
                <el-icon class="el-icon-document" />
              </div>
            </div>
          </div>
          <el-alert type="info" :closable="false" class="mt-3" show-icon>
            فایل ورودی باید با فرمت اکسل بوده و در ستون اول آن لیستی از کد
            رهگیری ( imei ) دستگاه ها وجود داشته باشد.
          </el-alert>
        </el-col>
        <el-col v-else-if="result.show" :sm="24" class="mb-3">
          <h5 class="text-center mt-5 mb-5">
            <i
              class="el-icon-success text-success mb-2"
              style="font-size: 45px"
            />
            <br />
            <span class="mb-2" style="font-size: 30px"
              >{{ result.createdDevicesCount }} </span
            ><br />
            دستگاه با موفقیت ثبت شد
          </h5>
          <div v-if="result.wrongImeis.length > 0">
            <hr />
            <p class="text-center text-danger mt-5">
              <i class="el-icon-error mb-2" style="font-size:20px" />
              <span class="ml-1 mr-1">{{ result.wrongImeis.length }}</span>
              کد رهگیری تکراری یا دارای مشکل است
            </p>
            <table
              class="table table-header-error table-bordered mt-4 text-center"
            >
              <tbody>
                <tr>
                  <th>کدهای رهگیری دارای مشکل</th>
                </tr>
                <tr v-for="(item, i) in result.wrongImeis" :key="i">
                  <td>{{ item }}</td>
                </tr>
              </tbody>
            </table>
            <div class="text-center">
              <el-button type="text" @click="clear">بازگشت</el-button>
            </div>
          </div>
        </el-col>
      </el-row>
      <div class="text-center" style="margin:20px 0 -10px">
        <el-button type="primary" native-type="submit" :loading="addLoading">
          ثبت
        </el-button>
        <el-button :disabled="addLoading" @click="visible = false">
          انصراف
        </el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
import DropZone from '@/components/DropZone'
import axios from '@/plugins/axios'
export default {
  name: 'ImportDevicesForm',
  components: {
    DropZone
  },
  props: {
    show: { type: Boolean, default: false }
  },
  data() {
    return {
      loading: false,
      addLoading: false,
      file: null,
      form: {},
      result: {
        show: false,
        createdDevicesCount: 0,
        wrongImeis: []
      }
    }
  },
  computed: {
    visible: {
      get() {
        return this.show
      },
      set(val) {
        return this.$emit('update:show', !!val)
      }
    }
  },
  watch: {
    show(val) {
      if (!val) this.clear()
    }
  },
  methods: {
    handleFileChange($event) {
      this.file = $event
    },
    clear() {
      this.file = null
      this.result.show = false
      this.result.createdDevicesCount = 0
      this.result.wrongImeis = []
    },
    submit() {
      this.addLoading = true
      this.upload()
        .then(response => {
          this.result.show = true
          this.result.createdDevicesCount = response.createdDevicesCount
          this.result.wrongImeis = response.wrongImeis
        })
        .catch(error => {
          this.$message.error(error)
        })
        .finally(() => {
          this.addLoading = false
        })
    },
    upload() {
      return this.$validate().then(() => {
        return new Promise(async (resolve, reject) => {
          if (!this.file) reject('لطفا فایل را انتخاب کنید')
          let data = new FormData()
          data.append('devices', this.file)
          return axios
            .post(`api/importDevices`, data)
            .then(response => {
              resolve(response.data)
            })
            .catch(() => {
              reject('مشکلی در آپلود فایل به وجود آمده است')
            })
        })
      })
    }
  }
}
</script>
<style lang="scss">
.v-image-picker-preview-image {
  width: 110px !important;
  height: 110px !important;
  text-align: center;
  .el-icon-document {
    font-size: 40px;
    margin-top: 35px;
    color: #aaa;
  }
}
</style>
